import { formatMoneyWithCurrencyCode } from '@oneview/utils';
import { isNumber } from 'lodash';
import { useMemo } from 'react';
import { useGetQuotesFxRateQuery } from '@oneview/queries/quote';
import { useCurrentBaseCurrency } from './useCurrentBaseCurrency';

type TransformedValueOptions = {
    separator: string;
    hideOriginalValue: boolean;
};

export const useTranslateFx = (exchangeCurrency?: string, staleTime?: number) => {
    const selectedBaseCurrency = useCurrentBaseCurrency();
    const isCurrenciesMatch = selectedBaseCurrency === exchangeCurrency;

    const {
        data: quoteFxRate,
        isLoading: isFxRateLoading,
        isFetching: isFxRateFetching,
        isError,
    } = useGetQuotesFxRateQuery({
        symbols: [`${exchangeCurrency}/${selectedBaseCurrency}`],
        enabled: Boolean(exchangeCurrency) && Boolean(selectedBaseCurrency) && !isCurrenciesMatch,
        staleTime,
    });

    const fxRate = useMemo(() => {
        if (isCurrenciesMatch) return 1;
        return quoteFxRate?.[0]?.lastPrice || 1;
    }, [quoteFxRate, isCurrenciesMatch]);

    const getTransformedValue = (value?: number, options?: Partial<TransformedValueOptions>) => {
        const { separator = ' / ', hideOriginalValue = false } = options || {};

        return `${`${isNumber(value) ? formatMoneyWithCurrencyCode(value * fxRate, { currency: selectedBaseCurrency }) : ''}`}${!hideOriginalValue && !isCurrenciesMatch ? `${separator}${formatMoneyWithCurrencyCode(value, { currency: exchangeCurrency })}` : ''}`;
    };

    return {
        getTransformedValue,
        fxRate,
        baseCurrency: selectedBaseCurrency,
        isBaseLoading: !isCurrenciesMatch && isFxRateLoading,
        isBaseFetching: !isCurrenciesMatch && isFxRateFetching,
        isLoading: !isCurrenciesMatch && (isFxRateLoading || isFxRateFetching),
        isError,
    };
};
